import React from 'react';
import { motion } from 'framer-motion';
import { CrosshairIcon, WindIcon, RotateCcwIcon, ShieldCheckIcon, TrendingUpIcon } from 'lucide-react';
import { benefits, Benefit } from '../data/content';
const icons: Record<Benefit['icon'], typeof WindIcon> = {
  focus: CrosshairIcon,
  wind: WindIcon,
  rotate: RotateCcwIcon,
  shield: ShieldCheckIcon,
  trending: TrendingUpIcon
};
export function Benefits() {
  return <section className="w-full py-12 sm:py-16" aria-labelledby="logros-title" data-id="element-11" data-mp="3qsfdm8nkvu87">
      <div className="mx-auto max-w-6xl px-6" data-id="element-12" data-mp="3mp98x5g46b3u">
        <div className="mx-auto max-w-2xl text-center" data-id="element-13" data-mp="3hqxzgvtqe2m5">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-oliva" data-id="element-14" data-mp="3hrheo4rzycwh">
            Resultados
          </p>
          <h2 id="logros-title" className="font-display text-3xl font-semibold tracking-tight text-tinta sm:text-4xl" data-id="element-15" data-mp="3cu7h21ugeuxk">
            Lo que vas a lograr entrenando tu mente
          </h2>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-16" data-mp="2qodgymupba7">
          {benefits.map((benefit, index) => {
          const Icon = icons[benefit.icon];
          return <motion.article key={benefit.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.45,
            delay: index * 0.06
          }} className="rounded-4xl bg-white p-8 shadow-soft" data-id="element-17" data-mp="3oyxsc0z51wlu" data-mpi={index}>
                <span className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-agua/25 text-bosque" data-id="element-18" data-mp="qilervsockx2">
                  <Icon className="h-6 w-6" strokeWidth={1.6} aria-hidden="true" data-id="element-19" data-mp="gqfnype5s9jg" />
                </span>
                <h3 className="font-display text-xl font-semibold text-tinta" data-id="element-20" data-mp="14g1qnmtqp6w7">
                  {benefit.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-tinta/65" data-id="element-21" data-mp="198uqbwacpp1f">
                  {benefit.text}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}